import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup";
import { HeadLogo } from "../components/headLogo";
import { GameIntroHeader } from "../components/gameIntroHeader";
import { CheckMoreButtons } from "../components/checkMoreButtons";
import { ModeIndication } from "../components/modeIndication";
import {LocationImageDisplay} from "../components/locationImageDisplay";


function AskAIGameView({
  mode,
  title,
  currentStep,
  inputValue,
  onInputChange,
  submitted,
  onSubmit,
  answer,
  loading,
  imageKey,
  onComplete
}) {
  return (
    <div className="speechbubble-layout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={currentStep} title={title} />
      <ModeIndication mode={mode} />
      <div className="speechbubble-content">
        <GameIntroHeader
          title="Ask the AI"
          description="You get one question. Make it count!"
        />
<div className="askAI-infoContent">
        {!answer ? (
          <textarea
            className="ask-ai-input"
            placeholder="Type your question here..."
            value={inputValue}
            onChange={onInputChange}
          />
        ) : (
          <div className="ask-ai-userInputValue">{inputValue}</div>
        )}

        {loading && (
          <div className="ask-ai-loading">
            <div className="spinner"></div>
            <div>Thinking...</div>
          </div>
        )}
        {answer && (
          <div className="ask-ai-answer">
            <div className="ask-ai-answer-label">AI says:</div>
            <div className="ask-ai-answer-text">{answer}</div>
          </div>
        )}

        {!submitted ? (
          <button
            className="ask-ai-submit"
            onClick={onSubmit}
            disabled={!inputValue.trim()}
          >
            Submit
          </button>
        ) : answer && !loading ? (
          <CheckMoreButtons
          onNext={onComplete}
          />
        ) : null}
        </div>
      </div>
        <LocationImageDisplay imageKey={imageKey} dynamicHeight="40vh" />
    </div>
  );
}

export { AskAIGameView };
